function ChosenColor(props) {
    const decode_backend_color = (color) => {
      return color >= 0 ? color : 256 + color;
    }
    
    const red = decode_backend_color(props.color.red);
    const green = decode_backend_color(props.color.green);
    const blue = decode_backend_color(props.color.blue);
    const rgbString = `rgb(${red}, ${green}, ${blue})`;
    const hexString = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`.toUpperCase();
    
    return(
        <div
          className="chosen-color"
          data-color={hexString}
          style={{
            backgroundColor: rgbString,
          }}
        ></div>
    );
}

export default ChosenColor;